// extracted by mini-css-extract-plugin
var _1 = "FloatingTooltipContent-moduletooltip__S6Uao";
var _2 = "FloatingTooltipContent-moduletooltipText__j4nNU";
export { _1 as "tooltip", _2 as "tooltipText" }
